import { render, staticRenderFns } from "./DatatableBulkItem.vue?vue&type=template&id=b0982ec8&"
import script from "./DatatableBulkItem.vue?vue&type=script&lang=js&"
export * from "./DatatableBulkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports